import type { RequestTabId } from './types'

export type RequestTabDefinition = {
  id: RequestTabId
  label: string
  labelSv: string
}

export const REQUEST_TAB_DEFINITIONS: RequestTabDefinition[] = [
  {
    id: 'explore',
    label: 'Explore',
    labelSv: 'Utforska',
  },
  {
    id: 'checkout',
    label: 'Checkout',
    labelSv: 'Kassa',
  },
  {
    id: 'delivery',
    label: 'Delivery',
    labelSv: 'Leverans',
  },
]
